import React from 'react';
import PrivateLayout from '../../../layouts/private';

class QualityReportScreen extends React.Component {

  render() {
    const ifUrl = 'https://dairydelivery.conformiz.com/QualityList/Quality_report_view_in_mobile';

    return (
      <PrivateLayout hideBalanceBox screenTitle="Quality Report">

        <iframe
          style={{
            width: '100%',
            height: '100%',
            border: 0,
            scrollbarWidth: 5,
          }}
          src={ifUrl}
        ></iframe>

      </PrivateLayout>
    );
  }

}

export default QualityReportScreen;
